import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import ProviderCard from './ProviderCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProviderSlider.css";
import {Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";
import {keydownHandler} from "../utils/commonHelper";
import TypingMessage from "./TypingMessage";
import {ROLE_SYSTEM} from "../utils/constants";
import {StartOverIcon} from "./Icons";

const ProviderSlider = ({
                            buttonClick,
                            data: {urlData, buttons, goToSlide, onSlide, fromMap = false, providers = []},
                            role,
                            last,
                            buttonClicked,
                            scrollToBottom
                        }) => {
    const [physiciansData, setPhysiciansData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);

    let slider = useRef();
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: true,
        onInit: () => setTabIndex(0, 0),
        onReInit: () => setTabIndex(currentSlide, 0),
        afterChange: current => onSlide ? onSlide(current) : null,
        beforeChange: (oldIdx, newIdx) => beforeChange(oldIdx, newIdx),
    };

    useEffect(() => {
        if (!fromMap) {
            getData();
        }
    }, []);

    useEffect(() => {
        if (providers.length) {
            setPhysiciansData(providers)
        }
    }, [providers]);

    useEffect(() => {
        if (goToSlide !== false) {
            slider.current.slickGoTo(goToSlide);
        }
    }, [goToSlide]);

    const setTabIndex = (idx, tabIdx) => {
        const slide = document.querySelectorAll(".provider-slider .slick-slide[data-index=\"" + idx + "\"]")[0];
        if (slide) {
            slide.querySelectorAll(".provider-card a").forEach((link) => {
                link.tabIndex = tabIdx;
            });
        }
    };

    const beforeChange = (oldIdx, newIdx) => {
        setCurrentSlide(newIdx);
        setTabIndex(oldIdx, -1);
        setTabIndex(newIdx, 0);
    };

    const getData = () => {
        setIsLoading(true);
        fetch(urlData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Request-Method': 'GET',
                    'Access-Control-Request-Headers': 'Content-Type, Authorization'
                }
            }
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                let data = result !== undefined ? result : {};
                setPhysiciansData(data);
                setIsLoading(false);
                if (!fromMap) {
                    scrollToBottom()
                }
            });
    };

    const showMap = () => {
        window.parent.postMessage({'name': 'showMap', value: physiciansData}, '*')
    }

    const showList = () => {
        window.parent.postMessage({'name': 'showList', value: physiciansData}, '*')
    }

    return <>
        <div className="provider-slider">
            {
                isLoading && !fromMap ? <TypingMessage/> : ''
            }
            <Slider ref={slider} {...settings}>
                {
                    physiciansData.length > 0 ?
                        physiciansData.map((item, index) => {
                            return <ProviderCard data={item} key={item.id}/>;
                        }) : ''
                }
            </Slider>
        </div>
        {
            buttons !== undefined && buttons.length > 0
            && !isLoading
            && role === ROLE_SYSTEM
            && last
            && !buttonClicked
                ?
                <Row className={"message-buttons provider-buttons visible"}>
                    <React.Fragment key={'msg_btn_show_map'}>
                        <a className={"template__href show_map"}
                           tabIndex={0}
                           onKeyDown={keydownHandler}
                           onClick={() => showMap()}>
                            <span>Show on map</span>
                        </a>
                    </React.Fragment>
                    <React.Fragment key={'msg_btn_show_list'}>
                        <a className={"template__href show_list"}
                           tabIndex={0}
                           onKeyDown={keydownHandler}
                           onClick={() => showList()}>
                            <span>List view</span>
                        </a>
                    </React.Fragment>
                    <React.Fragment key={'msg_btn_different'}>
                        <a className={"template__href different_provider"}
                           tabIndex={0}
                           onKeyDown={keydownHandler}
                           onClick={() => buttonClick('Find a Provider\n', '')}>
                            <div className="title">Find a different<br/>provider</div>
                        </a>
                    </React.Fragment>
                    {
                        buttons.map((button, key) =>
                            <React.Fragment key={'msg_btn_' + key}>
                                {
                                    (buttons.length > 1 && (
                                        button.onNewLine
                                        || (button.title === "Start Over" && !button.hasOwnProperty('onNewLine'))
                                    )) ? <br/> : ""
                                }
                                <a className={"template__href " + button.class}
                                   tabIndex={0}
                                   onKeyDown={keydownHandler}
                                   onClick={() => buttonClick(button.title, button.url)}
                                >
                                    <span>
                                        {
                                            (button.title === "Start Over") ?
                                                <div style={{display: "flex", marginTop: "9px"}}>
                                                    <StartOverIcon className="icon"/>
                                                    <span>{button.title}</span>
                                                </div>
                                                :
                                                button.title
                                        }
                                        {button.url && <FontAwesomeIcon icon={faExternalLinkAlt}/>}
                                    </span>
                                </a>
                            </React.Fragment>
                        )
                    }
                </Row> : ''
        }
    </>;
};

export default ProviderSlider;
